import { render, staticRenderFns } from "./AdvertisementForm.vue?vue&type=template&id=f4d3dab6&scoped=true&"
import script from "./AdvertisementForm.vue?vue&type=script&lang=js&"
export * from "./AdvertisementForm.vue?vue&type=script&lang=js&"
import style1 from "./AdvertisementForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3dab6",
  null
  
)

export default component.exports